import PaginationParameters from "../pagination-parameters";
import { parseOrThrow } from "_shared/_utilities/zod-schema-parser";
import { z } from "zod";

export type PaginationParametersParams = z.infer<typeof PaginationSchema.PaginationZ>;
export type PaginationJSON = z.infer<typeof PaginationSchema.PaginationJSONZ>;

export default class PaginationSchema {
  public static readonly type = z.custom<PaginationParameters>(
    (data) => data instanceof PaginationParameters,
    "Not a valid paginationParameters instance",
  );
  public static readonly PaginationJSONZ = z.object({
    pageIndex: z.number().int().nonnegative(),
    pageSize: z.number().int().nonnegative(),
  });
  public static readonly PaginationZ = z.object({
    pageIndex: z.number().int().nonnegative(),
    pageSize: z.number().int().nonnegative(),
  });

  public static validate(values: unknown): PaginationParametersParams {
    return parseOrThrow(PaginationSchema.PaginationZ, values, {
      logError: true,
      schemaName: "PaginationSchema",
      operation: "validate",
      payloadSample: values,
    });
  }

  public static deserialize(json: unknown): PaginationParametersParams {
    const parsed = parseOrThrow(PaginationSchema.PaginationJSONZ, json, {
      logError: true,
      schemaName: "PaginationSchema",
      operation: "deserialize",
      payloadSample: json,
    });
    return {
      pageIndex: parsed.pageIndex,
      pageSize: parsed.pageSize,
    };
  }

  public static serialize(pagination: PaginationParametersParams): PaginationParametersParams {
    const validated = parseOrThrow(PaginationSchema.PaginationZ, pagination, {
      logError: true,
      schemaName: "PaginationSchema",
      operation: "serialize",
      payloadSample: pagination,
    });
    return {
      pageIndex: validated.pageIndex,
      pageSize: validated.pageSize,
    };
  }
}
